import { render, staticRenderFns } from "./ChannelCalendar.vue?vue&type=template&id=09f56284&lang=pug&"
import script from "./ChannelCalendar.vue?vue&type=script&lang=js&"
export * from "./ChannelCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports